import { DefaultMessages, ProgramThemeMessages, SegmentSpecificMessages } from '@sheerid/jslib';
import { RecursivePartial } from '../types/types';


type LibraryMessages = DefaultMessages & SegmentSpecificMessages & ProgramThemeMessages;

type ThisProjectMessages = {
    birthDateMonth: string,
    birthDateDay: string,
    birthDateYear: string,
};


export const messagesEN: RecursivePartial<LibraryMessages & ThisProjectMessages> = {
    phoneNumber: 'Phone',
    birthDateMonth: 'Month',
    birthDateDay: 'Day',
    birthDateYear: 'Year',
    infoShared1: 'By clicking, I agree to receive marketing communications from Sleep Number through text messages and calls which could be sent via an automatic telephone dialing system and may be recorded or monitored. Message and data rates may apply. US phone numbers only. <br><br>I consent to processing my information for the purpose of verifying my eligibility as described within the {privacyPolicyLink}',
    infoShared2: '. I understand that my information will be shared with {companyName}. ',
    step: {
        personalInfo: {
            title: 'Unlock this<br>Military-Only Offer',
        },
        docUpload: {
            submitButtonLabel: 'SUBMIT',
        },
        success: {
            redirectButtonText: 'USE CODE NOW',
            subtitle: 'Here is your personal coupon code.<br>It is unique to you and can only be used once.',
        },
    },
};
